export const copyToClipboard = (
  text: string,
  successCallback?: () => void,
  failCallback?: () => void,
  html?: string,
) => {
  const copyPlainText = () =>
    navigator.clipboard.writeText(text).then(
      () => {
        if (successCallback) {
          successCallback();
        }
      },
      () => {
        if (failCallback) {
          failCallback();
        }
      },
    );

  const copyHtmlText = () => {
    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([html!], { type: 'text/html' }),
      'text/plain': new Blob([text], { type: 'text/plain' }),
    });

    return navigator.clipboard.write([clipboardItem]).then(
      () => {
        if (successCallback) {
          successCallback();
        }
      },
      () => {
        // Fallback to plain text if ClipboardItem fails
        copyPlainText();
      },
    );
  };

  // If HTML is provided, use ClipboardItem to preserve formatting
  if (html) {
    copyHtmlText();
  } else {
    // Plain text copy (original behavior)
    copyPlainText();
  }
};
